/** @format */

import { CategoryCard, HomrHeaderResponse, TaxonomyCategory } from './shop-by-category.types';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map } from 'rxjs';

import { HomrDataService } from '@shared/homr/data-access';
import { toSignal } from '@angular/core/rxjs-interop';

const IMAGE_LOCATION = 'https://images.dickssportinggoods.com/marketing/';
@Component({
  selector: 'shared-favorites-components-shop-by-category',
  templateUrl: './shop-by-category.component.html',
  styleUrl: './shop-by-category.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class ShopByCategoryComponent {
  private readonly homrDataService = inject(HomrDataService);
  private readonly categories$: Observable<CategoryCard[]> = this.homrDataService
    .getData$('header', 2, 'default')
    .pipe(
      map((response: unknown): CategoryCard[] =>
        ((response as HomrHeaderResponse).content?.Taxonomy2 ?? [])
          .map((category) => ({
            title: category.title,
            link: category.link,
            imgUrl: this.getCategoryImageUrl(category),
          }))
          .filter((category) => category.imgUrl?.length > 0),
      ),
    );

  // Calling toSignal afterwards because the observable needed explicit typing to properly map the data, and that typing isn't compatible with the initial value of the signal
  private readonly categoriesSignal = toSignal(this.categories$, {
    initialValue: [] as CategoryCard[],
  });

  get categories(): CategoryCard[] {
    return this.categoriesSignal();
  }

  private getCategoryImageUrl(category: TaxonomyCategory): string | null {
    const imageUpload = category.flyoutImage?.[0]?.imageUpload;
    if (!imageUpload) {
      return null;
    }
    return IMAGE_LOCATION + imageUpload;
  }
}
